/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClubLogoList } from '../../models/club-logo-list';

export interface GetClublogotypesList$Params {
}

export function getClublogotypesList(http: HttpClient, rootUrl: string, params?: GetClublogotypesList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClubLogoList>>> {
  const rb = new RequestBuilder(rootUrl, getClublogotypesList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClubLogoList>>;
    })
  );
}

getClublogotypesList.PATH = '/clublogotypes';
